interface FormatCurrencyOptions {
  // shown for null, undefined, empty or non-numeric values; defaults to zero dollars
  fallback?: string;
  decimals?: number;
}

export const formatCurrency = (value: number | string | null | undefined, { fallback, decimals = 2 }: FormatCurrencyOptions = {}): string => {
  const amount = value === null || value === undefined || value === '' ? NaN : Number(value);
  if (Number.isNaN(amount) && fallback !== undefined) {
    return fallback;
  }

  return (Number.isNaN(amount) ? 0 : amount).toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
};
